/* eslint-disable no-restricted-syntax */
// @mui material components
import {
  CircularProgress,
  Backdrop,
  Snackbar,
  Alert,
  Card,
  Icon,
  Button,
  ListItem,
  ListItemText,
  Divider,
  Grid,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios.js";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";
import MDBox from "theme/components/MDBox";
// import MDInput from "theme/components/MDInput";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";
import usePageTitle from "app/pageTitle";

function LeadPage() {
  const pageTitle = "Lead";
  usePageTitle(pageTitle);
  const { ref } = useParams();
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
    setShowLoading(false);
    setSeverity("error");
  };

  const [pageLoaded, setPageLoaded] = useState(false);
  const [resultData, setResultData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/leads/buckets/${ref}/lead.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setResultData(result.data.data);

            setPageLoaded(true);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <MDBox mb={5}>
        <MDBox display="flex" justifyContent="space-between" mb={2}>
          <MDBox>
            <Button
              color="dark"
              size="small"
              startIcon={<Icon>west</Icon>}
              onClick={() => {
                if (window.history.length > 1) {
                  window.history.back();
                } else {
                  navigate(`/leads/buckets/`);
                }
              }}
            >
              Back
            </Button>
          </MDBox>
        </MDBox>
        {pageLoaded && (
          <MDBox mt={1}>
            <MDBox mb={3}>
              <Card>
                <MDBox p={1.5} align="center">
                  <MDTypography fontSize={24}>
                    <Icon>person_alt</Icon>
                  </MDTypography>
                  <MDTypography mt={-1} variant="h6" fontWeight="regular">
                    {resultData.name}
                  </MDTypography>
                </MDBox>
              </Card>
            </MDBox>
            <MDBox>
              <Card>
                <MDBox p={2}>
                  <MDBox mb={3}>
                    <ListItem divider>
                      <ListItemText
                        primary={
                          <MDTypography variant="h6" fontSize={13}>
                            Phone Number
                          </MDTypography>
                        }
                        secondary={resultData.phone_number ?? "N/A"}
                      />
                      <MDBox>
                        <Icon>call</Icon>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                  <MDBox mb={5}>
                    <ListItem divider>
                      <ListItemText
                        primary={
                          <MDTypography variant="h6" fontSize={13}>
                            Email Address
                          </MDTypography>
                        }
                        secondary={resultData.email_address ?? "N/A"}
                      />
                      <MDBox>
                        <Icon>email</Icon>
                      </MDBox>
                    </ListItem>
                  </MDBox>
                  {resultData.attributes.map((attr) => (
                    <MDBox mb={3}>
                      <ListItem divider>
                        <ListItemText
                          primary={
                            <MDTypography variant="h6" fontSize={13}>
                              {attr.display_name}
                            </MDTypography>
                          }
                          secondary={attr.value}
                        />
                        <MDBox>
                          <Icon color="info">info_outline</Icon>
                        </MDBox>
                      </ListItem>
                    </MDBox>
                  ))}
                </MDBox>
              </Card>
            </MDBox>
            <MDBox mt={5}>
              <Grid container spacing={3}>
                <Grid item xs={6} md={6} lg={6}>
                  <MDButton
                    variant="outlined"
                    color="primary"
                    fullWidth
                    startIcon={<Icon>call</Icon>}
                    onClick={() => {
                      window.open(`tel:${resultData.phone_number}`, "_system");
                    }}
                    disabled={resultData.phone_number ? false : true}
                    size="large"
                  >
                    Call
                  </MDButton>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <MDButton
                    variant="outlined"
                    color="primary"
                    fullWidth
                    startIcon={<Icon>email</Icon>}
                    onClick={() => {
                      window.open(
                        `mailto:${resultData.name}<${resultData.email_address}>`,
                      );
                    }}
                    disabled={resultData.email_address ? false : true}
                    size="large"
                  >
                    Email
                  </MDButton>
                </Grid>
              </Grid>
              <MDBox mt={4}>
                <MDButton
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => {
                    alert(
                      "Expecting a CTA? Impatience killed the greedy fox! You be fox?",
                    );
                  }}
                  size="large"
                >
                  Convert Lead
                </MDButton>
              </MDBox>
            </MDBox>
          </MDBox>
        )}
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default LeadPage;
